var klaviyo = klaviyo || [];
klaviyo.init({
  account: "W48it8",
  platform: "shopify"
});
klaviyo.enable("backinstock", {
  trigger: {
    product_page_text: "Être alerté",
    product_page_class: "quick-add__submit button event-button",
    product_page_text_align: "center",
    product_page_margin: "0px",
    alternate_anchor: "AddToCart",
    replace_anchor: true
  },
  modal: {
    headline: "{product_name}",
    body_content: "S'inscrire pour recevoir une notification lorsque la billetterie est ouverte.",
    email_field_label: "Email",
    button_label: "M'avertir de la disponibilité",
    close_label: "Fermer",
    subscription_success_label: "C'est fait ! Nous vous tiendrons au courant lorsque la billetterie sera ouverte.",
    footer_content: '',
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#693935",
    button_text_color: "#fff",
    button_background_color: "#F8AE00",
    close_button_color: "#000",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500"
  }
});